import * as PIXI from "pixi.js";
import { Color, Rect, Scale, Size } from "../MyHelpers";

export class WinLineMarkerPIXIAPP
{
	//public element: HTMLElement;
	//public containerElement: HTMLElement;

	public lineIndex: number;

	public elementPIXIAPP : PIXI.Container = null;
	public elementTextPIXIAPP : PIXI.Text = null;
	public constructor() 
	{		

	}

	public Show(lineIndex: number): void {
		//this.element.innerHTML = "" + (lineIndex + 1);
		//this.element.style.visibility = "visible";

		this.elementPIXIAPP.visible = true;
		this.elementTextPIXIAPP.text = (lineIndex + 1)
	}

	public Hide(): void {
		//this.element.style.visibility = "hidden";
		this.elementPIXIAPP.visible = false;
	}

	public CreatePIXIAPP(){
		this.elementPIXIAPP = new PIXI.Container;
		this.elementPIXIAPP.name = "Line-marker";
		//this.elementPIXIAPP.width =  Scale.W(50);
		//this.elementPIXIAPP.height = Scale.fh(10);
		
		let graphics = new PIXI.Graphics();
		graphics.name = "Background";
		graphics.beginFill(new PIXI.Color("gold"));
		// graphics.tint ="yellow";
		graphics.alpha = 0.8;
		//graphics.pivot.set(Scale.W(50)/2,Scale.H(50)/2);
		graphics.drawRoundedRect( Scale.W(0) , Scale.W(4), Scale.W(65), Scale.H(35),50);
		graphics.endFill();
			
		this.elementPIXIAPP.addChild(graphics);

		
		this.elementTextPIXIAPP = new PIXI.Text("000", {
            fontFamily: 'NotoSansDisplay-Bold',			
			fontSize: Scale.fh(25),			
			fontWeight: 'bold',
			fill: ["white"], // gradient
			stroke: 'black',
			strokeThickness:  Scale.fh(8),			
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
        });		
		this.elementTextPIXIAPP.anchor.set(0.5,0.5);
		this.elementTextPIXIAPP.position.set( Scale.W(65) / 2, this.elementTextPIXIAPP.height/2);
		this.elementTextPIXIAPP.name = "WinLineText";
		this.elementPIXIAPP.addChild(this.elementTextPIXIAPP);

		return this.elementPIXIAPP;
	}
}

export class WinLineMarkersPIXIAPP
{
	private leftMarkers: WinLineMarkerPIXIAPP[] = [];
	private leftVisibleMarker: WinLineMarkerPIXIAPP = null;

	private rightMarkers: WinLineMarkerPIXIAPP[] = [];
	private rightVisibleMarker: WinLineMarkerPIXIAPP = null;

	//private leftContainer: HTMLElement = null;
	//private rightContainer: HTMLElement = null;

	//private view: HTMLElement = null;
	private lines: number[][] = [];

	private slotWindow : Rect = null;
	private slotWindowSymbolSize : Size = null;
	private symbolSize : Size = null;
	constructor(slotWindow: Rect, slotWindowSymbolSize: Size, lines: number[][] , symbolSize : Size) 
	{
		this.slotWindowSymbolSize = slotWindowSymbolSize;
		this.slotWindow = slotWindow;
		this.symbolSize = symbolSize;

		

		this.lines = lines;
	}

	public Show(lineIndex: number, color: Color): void {

		if (this.leftVisibleMarker != null) {
			this.leftVisibleMarker.Hide();
		}

		if (this.rightVisibleMarker != null) {
			this.rightVisibleMarker.Hide();
		}

		let rowLeft = this.lines[lineIndex][0];

		this.leftVisibleMarker = this.leftMarkers[rowLeft];
		//this.leftVisibleMarker.element.style.backgroundColor = color.toRgb();
		this.leftVisibleMarker.Show(lineIndex);

		let rowRight = this.lines[lineIndex][this.lines[lineIndex].length -1];

		this.rightVisibleMarker = this.rightMarkers[rowRight];
		//this.rightVisibleMarker.element.style.backgroundColor = color.toRgb();
		this.rightVisibleMarker.Show(lineIndex);
	}

	public Hide(): void {
		if (this.leftVisibleMarker != null) {
			this.leftVisibleMarker.Hide();
			this.leftVisibleMarker = null;
		}

		if (this.rightVisibleMarker != null) {
			this.rightVisibleMarker.Hide();
			this.rightVisibleMarker = null;
		}
	}

	public LeftView(): HTMLElement {
		return null;
	}

	public RightView(): HTMLElement {
		return null;
	}

	public CreateViewAPP(){
		let leftWidth: number = Scale.W(60);
		let leftOffset: number = Scale.X(10);

		let rightWidth: number = Scale.W(60);
		let rightOffset: number = Scale.X(5);

		let leftContainePixiAPP = new PIXI.Container;
		leftContainePixiAPP.name = "leftContainePixiAPP";
		leftContainePixiAPP.width = leftWidth;
		leftContainePixiAPP.height = this.slotWindow.height;
		leftContainePixiAPP.position.set(this.slotWindow.x - leftWidth - leftOffset,this.slotWindow.y);		

		let rightContainerPixiAPP = new PIXI.Container;
		rightContainerPixiAPP.name = "rightContainerPixiAPP";
		rightContainerPixiAPP.width = rightWidth;
		rightContainerPixiAPP.height = this.slotWindow.height;
		rightContainerPixiAPP.position.set(this.slotWindow.x + this.slotWindow.width + rightOffset, this.slotWindow.y);
		
		let containerLAndR : PIXI.Container [ ] = [];
		containerLAndR.push(leftContainePixiAPP);
		containerLAndR.push(rightContainerPixiAPP);

		this.leftMarkers  = [];
		this.rightMarkers = [];
		for (let i = 0; i < this.slotWindowSymbolSize.Height; i++) {
			// create markers
			let leftMarker: WinLineMarkerPIXIAPP = new WinLineMarkerPIXIAPP();
			let rightMarker: WinLineMarkerPIXIAPP = new WinLineMarkerPIXIAPP();

			let viewLeft =  leftMarker.CreatePIXIAPP();
			//viewLeft.width = this.slotWindowSymbolSize.width;
			//viewLeft.height = this.slotWindowSymbolSize.height;
			viewLeft.position.set(0 , this.symbolSize.Height*i + this.symbolSize.Height/2);
			leftContainePixiAPP.addChild(viewLeft);			
			
			let viewRight =  rightMarker.CreatePIXIAPP();
			//viewRight.width = this.slotWindowSymbolSize.width;
			//viewRight.height = this.slotWindowSymbolSize.height;
			viewRight.position.set(0 , this.symbolSize.Height*i + this.symbolSize.Height/2);
			rightContainerPixiAPP.addChild(viewRight);
			
			// hide markers by default
			leftMarker.Hide();
			rightMarker.Hide();

			this.leftMarkers.push(leftMarker);
			this.rightMarkers.push(rightMarker);
		}

		return containerLAndR;
	}
}